module.exports = {
	"context": {
		"name": "Context",
		"type": "select",
		"default": "offline",
		"options": [
			{
				"key": "offline",
				"name": "Offline Rendering"
			},
			{
				"key": "realtime",
				"name": "Real-time"
			}
		]
	},
	"workflow": {
		"name": "Workflow",
		"type": "select",
		"default": "metalness",
		"options": [
			{
				"key": "metalness",
				"name": "Metalness"
			},
			{
				"key": "specular",
				"name": "Specular"
			}
		]
	},
	"microsurface": {
		"name": "Microsurface",
		"type": "select",
		"default": "roughness",
		"options": [
			{
				"key": "roughness",
				"name": "Roughness"
			},
			{
				"key": "gloss",
				"name": "Gloss"
			}
		]
	},
	"meshMimeType": {
		"name": "Mesh Format",
		"type": "select",
		"default": "application/x-fbx",
		"options": [
			{
				"key": "application/x-fbx",
				"name": "FBX"
			},
			{
				"key": "application/x-obj",
				"name": "OBJ"
			}
		]
	},
	"maxlod": {
		"name": "Maximum LOD",
		"type": "lod",
		"defaultIndex": 0
	},
	"highpoly": {
		"name": "Highpoly",
		"type": "checkbox",
		"default": false
	},
	"ztool": {
		"name": "Source ZTool",
		"type": "checkbox",
		"default": false
	},
	"lowerlod_meshes": {
		"name": "All LODs",
		"type": "checkbox",
		"default": false
	},
	"lowerlod_normals": {
		"name": "LOD Normals",
		"type": "checkbox",
		"default": false
	},
	"brushes": {
		"name": "Brushes",
		"type": "checkbox",
		"default": false
	}
}


//////////////////
// WEBPACK FOOTER
// ./src/data/asset/settings/3d.json
// module id = 2456
// module chunks = 0